import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SaleAction } from '../../store/actions';

class Transaction extends PureComponent {
  static propTypes = {
    deleteTransactionSale: PropTypes.func,
    getSale: PropTypes.func,
    permissions: PropTypes.arrayOf(PropTypes.string),
    sale: PropTypes.object,
    saleId: PropTypes.number,
  };

  componentDidMount() {
    this.props.getSale(this.props.saleId);
  }

  onDeleteTransaction(row) {
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.deleteTransactionSale(row.transactionable_id, row.id);
  }

  render() {
    const { permissions, sale } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Sale Transaction</h3>
            </div>
            <div className="card-body p-0">
              <table className="table table-striped text-nowrap">
                <thead>
                  <tr>
                    {permissions?.includes?.('sale.delete_transaction') && (
                      <th className="d-print-none">Action</th>
                    )}
                    <th>Transacted At</th>
                    <th className="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {sale?.transactions?.map?.(row => (
                    <tr key={row.id}>
                      {permissions?.includes?.('sale.delete_transaction') && (
                        <td className="d-print-none">
                          <div className="btn-group">
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => this.onDeleteTransaction(row)}
                              type="button"
                            >
                              <i className="fas fa-trash mr-1"></i>
                              Delete
                            </button>
                          </div>
                        </td>
                      )}
                      <td>{row.transacted_at}</td>
                      <td className="text-right">{row.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  permissions: state?.auth?.permissions,
  sale: state?.sale?.detail,
  saleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  deleteTransactionSale: (saleId, transactionId) =>
    dispatch(SaleAction.deleteTransactionSale(saleId, transactionId)),
  getSale: id => dispatch(SaleAction.getSale(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);
